import type { TeacherLessonListVM } from "@shared-kernel/application/ports/teacher/teacher-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveLessons = createApiThunk<TeacherLessonListVM[], void>(
  "lessons/retrieveLessons",
  async (_: void, { extra: { teacherRepository } }) => {
    return teacherRepository!.allLessons();
  },
);
